module.exports = __webpack_public_path__ + "img/arrow-bar-down.cd6739eb.svg";